import React from 'react'
import cx from 'classnames'
import { useDevice } from 'device'
import { useEntry } from 'intersection-observer'
import links from 'links'
import { track } from 'analytics'

import { useCollaborationProducts } from 'modules/collaborations'

import { Button } from 'components/inputs'
import { WidthContainer } from 'components/layout'

import ProductCarousel, { type ProductCarouselProps } from 'compositions/productLists/ProductCarousel/ProductCarousel'

import ViewMoreButton from './components/ViewMoreButton/ViewMoreButton'

import messages from './messages'


export type ProductsSectionProps = {
  excludeId?: number
  metadata: QueueModule.AddItemInput['metadata']
  type?: ProductCarouselProps['desktopType']
  withBrowseButton?: boolean
  withNonAuthRedirect?: boolean
  withoutLink?: boolean
}

const PRODUCTS_LIMIT = 6

const ProductsSection: React.FunctionComponent<ProductsSectionProps> = (props) => {
  const { excludeId, metadata, type = 'detailed', withBrowseButton = true, withNonAuthRedirect, withoutLink } = props

  const { isMobile } = useDevice()

  const [ ref, entry ] = useEntry({ once: true, observerProps: { rootMargin: '50%' } })
  const skip = !entry?.isIntersecting

  const { data, isFetching } = useCollaborationProducts({
    catalogueType: 'all',
    collaboration: 'saks',
    excludeId,
    limit: PRODUCTS_LIMIT,
    productsFeed: 'SAKS_SELECTED',
    skip,
  })

  const link = links.scentbirdSelect
  const extraNode = isMobile ? <ViewMoreButton to={link} /> : null

  return (
    <WidthContainer ref={ref} className={isMobile ? 'mt-24 pb-24' : 'mt-32 pb-40'}>
      <ProductCarousel
        desktopType={type}
        products={data}
        isFetching={isFetching}
        extraNode={extraNode}
        metadata={metadata}
        withNonAuthRedirect={withNonAuthRedirect}
        withoutLink={withoutLink}
        onProductButtonClick={(data) => {
          track('Banner click', {
            action: 'Add to queue',
            content: 'Scentbird select',
            placement: 'Page body',
            productId: data.id,
            productGender: data.gender,
            productFullName: data.fullName,
            productBrand: data.brandInfo.name,
            productCategory: data.category,
            productVolume: '0.27 oz, 50 ml',
          })
        }}
      />
      {
        withBrowseButton && (
          <div className={cx('text-center', isMobile ? 'mt-24' : 'mt-32')}>
            <Button
              title={messages.browse}
              to={link}
              style="primary"
              fullWidthOnMobile
              size={56}
              width={320}
              onClick={() => {
                track('Banner click', {
                  link,
                  action: 'link',
                  content: 'Scentbird select',
                  placement: 'Page body',
                })
              }}
            />
          </div>
        )
      }
    </WidthContainer>
  )
}

export default ProductsSection
